<template>
  <li style="width: 100%" class="struct" :id="'struct_0' + firstItem.facility_id">
    <div :class="['item-struct', firstItem.active ? 'active' : '', rowClass(firstItem)]"
      :title="firstItem.node_name_desc" @click.self="$emit('onClickItem', { node: firstItem, event: $event })">
      <img @click="$emit('onClickItem', { node: firstItem, event: $event })" :title="firstItem.node_name"
        :class="!firstItem.children.length ? 'ml-2' : ''"
        :src="require(`/public/images/24x24/${firstItem.image_index}.png`)" width="20" />
      <div class="unselectable ml-1 facility-name" disabled @click="$emit('onClickItem', { node: firstItem, event: $event })">
        {{ firstItem.node_name }}
      </div>
    </div>
  </li>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useStructure } from './useStructure.js';

const props = defineProps({
  firstItem: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['onClickItem']);

const { rowClass } = useStructure();
</script>

<style scoped lang="scss" src="./StyleStructure.scss"></style>